import WebsiteModal from "./WebsiteModal";

export class ContentsModal extends WebsiteModal {
    constructor(list) {
        super();

        this.list = list;
    }

    buildElement() {
        this.$modal = (
            eotwJSXFactory('div', {className: "modal modal--contents-list"}, [
                eotwJSXFactory('div', {className: "modal__bg"}),
                eotwJSXFactory('div', {className: "modal__container"}, [
                    eotwJSXFactory('div', {className: "bg-elements bg-elements--opacity-100"}, [
                        eotwJSXFactory('div', {className: "bg-element bg-element--modal bg-element-pos bg-element-pos--modal"})
                    ]),
                    eotwJSXFactory('button', {type: "button", className: "modal__close js-close-modal"}),
                    eotwJSXFactory('div', {className: "modal__text"}, [
                        eotwJSXFactory('div', {className: "contents-list contents-list--modal"}, [
                            eotwJSXFactory('h2', {className: "heading heading--2"}, ["Contents"]),
                            eotwJSXFactory('ul', {className: "contents-list__list"}, [
                                this.list
                            ])
                        ])
                    ])
                ])
            ])
        );
    }

    bindEvents() {
        this.$modal.on("click", ".js-toc-link", () => {
            this.close();
            return true;
        })
    }
}